const NON_DIGIT_REGEXP = /[^0-9]/g;

export default function removeNonDigits(value: string): string {
  return value.replace(NON_DIGIT_REGEXP, '');
}
